<template>
  <div
    class="table-of-content-blog"
    :class="{ 'is-stuck': isStuck }"
  >
    <UiComponentHeading
      as="paragraph"
      :level="5"
    >
      <slot />
    </UiComponentHeading>
    <UiComponentLabel id="table-of-content-blog">
      <slot />
    </UiComponentLabel>
    <div class="separator" />
    <div class="body">
      <UiComponentSelect
        v-if="content.length > 0"
        id="table-of-content-blog"
        :index="activeIndex"
        :options="content"
        @select:change="setActiveTitle"
      />
      <div class="list">
        <UiComponentParagraph
          v-for="(value, index) in content"
          :key="index"
          :class="{ active: index === activeIndex }"
          @click="onClick(index)"
        >
          {{ value }}
        </UiComponentParagraph>
      </div>
    </div>
  </div>
</template>

<script setup>
// Emitter
const emit = defineEmits([
  'select:change',
  'table-of-content:click',
  'table-of-content:toggle',
])

// Props
const props = defineProps({
  activeIndex: {
    default() {
      return 0
    },
    required: false,
    type: Number,
  },
  content: {
    default() {
      return []
    },
    required: true,
    type: Array,
  },
  isStuck: {
    default() {
      return false
    },
    required: false,
    type: Boolean,
  },
})

// Refs
const opened = ref(false)

// Methods
function onClick(index) {
  emit('table-of-content:click', index)
  emit('table-of-content:toggle', opened.value)
}

function setActiveTitle(value) {
  const newActiveIndex = props.content.findIndex(
    content => content === value,
  )
  emit('select:change', newActiveIndex)
}
</script>

<style lang="postcss" scoped>
.table-of-content-blog {
  @apply flex flex-col w-full bg-white z-40;

  @screen xl {
    @apply z-0;
  }

  &.is-stuck {
    .h5 {
      @apply text-sm leading-4;
    }

    .separator {
      @apply mt-0 h-0;
    }

    .body {
      .select {
        @apply flex mt-1 max-h-10 opacity-100 visible;
      }

      .list {
        @apply max-h-0 opacity-0 invisible;
      }
    }
  }

  label {
    @apply font-medium capitalize;

    @screen xl {
      @apply hidden;
    }
  }

  .h5 {
    @apply hidden;

    @screen xl {
      @apply flex transition-all duration-500 ease-in-out;
    }
  }

  .separator {
    @apply hidden;

    @screen xl {
      @apply mt-4 flex w-full h-px bg-grey-blue-200 transition-all duration-500 ease-in-out;
    }
  }

  .body {
    @apply flex flex-col w-full;

    .select {
      @apply mt-4 overflow-hidden;

      @screen xl {
        @apply mt-0 max-h-0 opacity-0 invisible transition-all duration-500 ease-in-out;
      }

      :deep(i) {
        z-index: 1;
      }
    }

    .list {
      @apply hidden;

      @screen xl {
        @apply flex flex-col w-full max-h-[2000px] transition-all duration-500 ease-in-out;
      }

      p {
        @apply mt-4 text-sm text-grey-blue-600 leading-6 cursor-pointer transition-all duration-300 ease-in-out;

        &:hover {
          @apply text-grey-blue-900;
        }

        &.active {
          @apply pl-2 text-grey-blue-900;
        }
      }
    }
  }
}
</style>
